import { type FC, type ComponentProps, type ReactNode } from 'react';
import classnames from 'classnames';
import { Link } from 'dibs-elements/exports/Link.tsx';
import { FormattedMessage } from 'dibs-react-intl';

import styles from './HpSharedHeader.scss';

type Props = {
    title?: ReactNode;
    subtitle?: string;
    viewMoreLink?: string | null;
    viewMoreText?: ReactNode;
    onViewMoreClick?: ComponentProps<typeof Link>['onClick'];
    dataTn?: string;
    size?: 'large' | 'larger';
};

const defaultViewMoreText = (
    <FormattedMessage id="HpSharedHeader.viewMore" defaultMessage="View More" />
);

export const HpSharedHeader: FC<Props> = ({
    title,
    subtitle,
    viewMoreLink,
    viewMoreText = defaultViewMoreText,
    onViewMoreClick,
    dataTn,
    size = 'large',
}) =>
    title ? (
        <div className={classnames(styles.headerContainer, styles[size])}>
            <div className={styles.titleWrapper}>
                <div
                    className={classnames(styles.title, styles[size])}
                    data-tn={dataTn ? `${dataTn}-title` : null}
                >
                    {title}
                </div>
                {viewMoreLink && (
                    <Link
                        className={classnames(styles.viewMore, styles[size])}
                        href={viewMoreLink}
                        dataTn={dataTn ? `${dataTn}-view-more-link` : `view-more-link`}
                        onClick={onViewMoreClick}
                    >
                        {viewMoreText}
                    </Link>
                )}
            </div>
            {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
        </div>
    ) : null;
